import { useLocation } from "react-router-dom";
import { BackButton } from "app/components/ui/buttons/BackButton";
import { useBookingSteps } from "../../hooks/useBookingSteps";
import { getBookingTunnel } from "../../utils/getBookingTunnel";

export type BookingBackButtonProps = {
	onClick?: () => void;
	className?: string;
};

export const BookingBackButton = ({ onClick, className }: BookingBackButtonProps) => {
	const { pathname } = useLocation();
	const tunnel = getBookingTunnel(pathname);
	const { steps, value } = useBookingSteps({ tunnel });
	const previousUrl = value > 0 ? steps[value - 1]?.to : undefined;

	if (!previousUrl) {
		return null;
	}

	return <BackButton to={previousUrl} onClick={onClick} className={className} />;
};
